//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { EmailPreviewInputItem } from './EmailPreviewInputItem';

export class CustomEmailTemplateInputItem extends EmailPreviewInputItem {
    OverwriteExisting: boolean = false;
    Title: string | null = null;

    constructor(initializer?: Partial<CustomEmailTemplateInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomEmailTemplateInputItem";
}
